import { ltLogger, getFetchFunction } from '../bootstrap';
import { buildCorsHeaders, createURL } from './url';
import * as logtypes from '../common/logtypes';

export const reportErrorLogs = (message, baseLogData, currentFormData = undefined) => {
  let logUrl = createURL('api/events/log');
  const headers = {
    'content-type': 'application/json; charset=utf-8',
    Accept: 'application/json',
    'phoenix-package': `${phoenixname};${phoenixversion};${
      process.env.BUILD_NUMBER
        ? process.env.BUILD_NUMBER.substring(0, 8)
        : 'none'
    };`,
  };

  // PHX-7148: Include currentFormData if available
  const logPayload = {
    message: message,
    level: 'info',
    ...baseLogData,
    ...(currentFormData && { currentFormData })
  };

  const body = JSON.stringify(logPayload);
  getFetchFunction()(logUrl, {
    method: 'POST',
    body,
    headers: { ...headers, ...buildCorsHeaders(logUrl) },
  })
    .then((response) => {
      if (response.statusCode >= 200 || response.statusCode < 300) {
        ltLogger(logtypes.INFO, undefined, {}, undefined, {
                  message:
                    'Sent ErrorLogs event successfully',
                });
      }
    })
    .catch((err) => {
      ltLogger(logtypes.ERROR, undefined, {}, undefined, {
        error: err,
      });
    });
};
